module.exports = __webpack_public_path__ + "img/success-tips.055aaa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/success-tips.png
// module id = 282
// module chunks = 2